<template>
  <div>
    <LDBsTable
      url="arena/vw-deactivated-events"
      defaultSort="id"
      defaultOrder="asc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
      :loadOnMount="false"
      :startSearchOpen="true"
      :disableSearch="!query.companyId"
    >
      <div class="form-group col-lg-12">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :options="clients"
          :initial-value="query.companyId"
          label="CLI_DSC"
          v-model="query.companyId"
          :reduce="(client) => client.CLI_ID"
        />
      </div>

      <div class="form-group col-lg-12">
        <label for="vehicle">{{ $t("vehicle") }}</label>
        <Combobox
          class="bg-white"
          name="vehicle"
          :placeholder="$t('select_a_item')"
          :options="vehiclesByClient"
          :initial-value="query.vehicleId"
          label="VEI_PLC"
          v-model="query.vehicleId"
          :reduce="(vehicle) => vehicle.VEI_ID"
          :disabled="!query.companyId"
        />
      </div>
    </LDBsTable>

    <!-- MODAL CONFIRM REMOVE TRIGGERED EVENTS -->
    <div
      class="modal fade"
      id="modalConfirmRemoveTriggeredEvent"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalConfirmRemoveTriggeredEventLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirmRemoveTriggeredEventLabel">
              Deseja remover este evento?
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul>
              <li>
                PLACA: <strong>{{ dataToRemove.plate }}</strong>
              </li>
              <li>
                EVENTO: <strong>{{ dataToRemove.eventDescription }}</strong>
              </li>
              <li>
                DATA/HORA PRIMEIRA OCORRÊNCIA: <strong>{{ formatDate(dataToRemove.firstOccurrence) }}</strong>
              </li>
              <li>
                DATA/HORA ÚLTIMA OCORRÊNCIA: <strong>{{ formatDate(dataToRemove.lastOccurrence) }}</strong>
              </li>
              <li>
                SITUAÇÃO: <strong>{{ getSituationLabel(dataToRemove.situation) }}</strong>
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              {{ $t("close") }}
            </button>

            <LoaderButton
              class="mt-3"
              @click="removeTriggeredEvent"
              :loading="isLoading"
            >
              {{ $t("confirm") }}
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LDBsTable from "@/components/shared/LDBsTable";
import Combobox from "@/components/shared/ComboBox";
import { mapState } from "vuex";
import moment from "moment";
import LoaderButton from '@/components/button/LoaderButton'
import { triggeredEventsSituationMapped } from '@/config/triggeredEventsSituationMapped.js'

export default {
  name: "ArenaCleanTriggeredEventList",

  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data() {
    return {
      columns: [
        {
          title: this.$t("board"),
          field: "vehiclePlate",
          sortable: true,
        },
        {
          title: this.$t("event"),
          field: "eventDescription",
          sortable: true,
        },
        {
          title: this.$t("datetime_first_occurency"),
          field: "firstOccurrence",
          sortable: true,
          formatter: (value) => {
            return this.formatDate(value);
          }
        },
        {
          title: this.$t("datetime_last_occurency"),
          field: "lastOccurrence",
          sortable: true,
          formatter: (value) => {
            return this.formatDate(value);
          }
        },
        {
          title: this.$t("situation"),
          field: "situation",
          sortable: true,
          formatter: (value) => {
            return triggeredEventsSituationMapped[value] || value
          },
        },
        {
          key: "id",
          field: "id",
          align: "center",
          width: "100%",
          formatter: function (value, row) {
            return `
              <button
                title="Desativar usuário"
                data-target="#modalConfirmRemoveTriggeredEvent"
                data-id='${value}'
                data-plate='${row.vehiclePlate}'
                data-eventname='${row.eventDescription}'
                data-firstoccurrence='${row.firstOccurrence}'
                data-lastoccurrence='${row.lastOccurrence}'
                data-situation='${row.situation}'
                data-toggle="modal"
                class="edit mb-1 btn btn-action btn-sm btn-danger btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-trash" />
              </button>
            `;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "arena_limpar_eventos_disparados" },
      },
      queryToUse: {},
      query: {
        companyId: undefined,
        vehicleId: undefined,
      },
      clientsById: {},
      dataToRemove: {
        id: "",
        plate: "",
        eventDescription: "",
        firstOccurrence: "",
        lastOccurrence: "",
        situation: "",
      }
    };
  },

  watch: {
    'query.companyId'(value) {
      const { dispatch, commit } = this.$store

      value
        ? dispatch('arena/fetchVehiclesByClient', { client: value })
        : commit('arena/setVehiclesByClient', [])
    }
  },

  computed: {
    ...mapState({
      lastquery: (state) => state.filtershistory.query,
      clients: state => state.arena.clients,
      isLoading: state => state.arena.isLoading,
      vehiclesByClient: state => state.arena.vehiclesByClient,
    }),
  },

  methods: {
    clear() {
      this.query.companyId = undefined;
      this.query.vehicleId = undefined;
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase();
    },

    async removeTriggeredEvent() {
      const { id } = this.dataToRemove

      await this.$store.dispatch(
        'arena/removeTriggeredEvent',
        { EDP_ID: id }
      )

      $("#modalConfirmRemoveTriggeredEvent").modal("hide");
      $("#search").trigger("click");
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },

    getSituationLabel(situation) {
      if (!situation) {
        return '-'
      }

      return triggeredEventsSituationMapped[situation] || situation
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery["cleantriggeredevents"]
      ? this.lastquery["cleantriggeredevents"]
      : this.query;
  },

  async mounted() {
    await this.$store.dispatch('arena/fetchClients')

    if (this.lastquery["cleantriggeredevents"]) {
      for (const [key, value] of Object.entries(
        this.lastquery["cleantriggeredevents"]
      )) {
        this.query[key] = value;
      }
    }

    this.queryToUse = this.query;

    this.clientsById = this.clients.reduce((acc, client) => {
      acc[client.CLI_ID] = client.CLI_DSC;

      return acc;
    }, {});

    const global = this

    $("#modalConfirmRemoveTriggeredEvent").on("show.bs.modal", function (event) {
      const button = $(event.relatedTarget);

      global.dataToRemove = {
        id: button.data("id"),
        plate: button.data("plate"),
        eventDescription: button.data("eventname"),
        firstOccurrence: button.data("firstoccurrence"),
        lastOccurrence: button.data("lastoccurrence"),
        situation: button.data("situation"),
      }
    });

    $("#modalConfirmRemoveTriggeredEvent").on("hide.bs.modal", function (event) {
      global.dataToRemove = {}
    });
  },

  destroyed() {
    this.$store.dispatch("filtershistory/setQuery", {
      key: "cleantriggeredevents",
      query: this.query,
    });
  },
};
</script>
